document.addEventListener("DOMContentLoaded", () => {

    console.log("EINZEK Motion Loaded");
(() => {
  const C = Object.assign({
    hero:true, sectionReveal:true, productHover:true, collectionHover:true,
    headerBlur:true, footerReveal:true, pageTransitions:true,
    magneticButtons:true, rippleButtons:true, progressBar:true,
    staggerDelay:120, parallaxStrength:.25
  }, window.EINZEK || {});

  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $ = (s, r=document) => [...r.querySelectorAll(s)];
  const visible = el => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  const txt = el => (el.textContent || "").trim().toLowerCase();
  const has = (el, s) => !!el.querySelector(s);
  const hrefs = el => $("a[href]", el).map(a => a.getAttribute("href") || "");

  function scoreHero(el) {
    if (!visible(el)) return 0;
    const r = el.getBoundingClientRect();
    let s = 0;
    if (r.top < innerHeight * .8) s += 3;
    if (r.height > innerHeight * .38) s += 3;
    if (has(el, "picture,img,video")) s += 3;
    if (has(el, "h1,h2")) s += 2;
    if (has(el, "a,button")) s += 1;
    if (el.matches('[role="banner"], section, .shopify-section, [id*="shopify-section"]')) s += 1;
    return s;
  }

  function scoreProductCard(el) {
    const h = hrefs(el).join(" ");
    let s = 0;
    if (h.includes("/products/")) s += 4;
    if (has(el, 'form[action*="/cart/add"], input[name="id"], button[name="add"]')) s += 4;
    if (has(el, "img,picture")) s += 2;
    if (txt(el).match(/\$|€|£|usd|eur|sale|sold out|add to cart|quick add/)) s += 2;
    return s;
  }

  function scoreCollectionCard(el) {
    const h = hrefs(el).join(" ");
    let s = 0;
    if (h.includes("/collections/")) s += 4;
    if (has(el, "img,picture")) s += 2;
    if (has(el, "h2,h3,h4")) s += 1;
    if (!h.includes("/products/")) s += 1;
    return s;
  }

  function mark(el, type) {
    if (!el || el.dataset.einzekComponent) return;
    el.dataset.einzekComponent = type;
  }

  function analyze(root=document) {
    const scope = root.nodeType === 1 ? root : document;
    const candidates = $("section, header, footer, main > div, .shopify-section, [id*='shopify-section'], article, li, div", scope);

    const header = $("header,[role='banner'],[data-section-type*='header']", scope)
      .find(el => has(el, "nav,a[href]"));
    if (C.headerBlur && header) mark(header, "header");

    const footer = $("footer,[role='contentinfo']", scope)[0];
    if (C.footerReveal && footer) mark(footer, "footer");

    if (C.hero) {
      candidates
        .map(el => [el, scoreHero(el)])
        .filter(x => x[1] >= 7)
        .sort((a,b) => b[1] - a[1])
        .slice(0, 2)
        .forEach(([el]) => mark(el, "hero"));
    }

    candidates.forEach(el => {
      if (C.productHover && scoreProductCard(el) >= 6) mark(el, "product-card");
      else if (C.collectionHover && scoreCollectionCard(el) >= 6) mark(el, "collection-card");
    });

    $("[data-einzek-component='product-card'],[data-einzek-component='collection-card']", scope).forEach(card => {
      const title = $("h1,h2,h3,h4,a", card).find(n => txt(n).length > 1);
      const price = $("[class*='price'],span,div", card).find(n => txt(n).match(/\$|€|£|usd|eur/));
      const quick = $("button,a", card).find(n => txt(n).match(/add|quick|cart|choose|view/));
      if (title) title.dataset.einzekCardTitle = "";
      if (price) price.dataset.einzekCardPrice = "";
      if (quick) quick.dataset.einzekQuickAdd = "";
    });

    if (C.sectionReveal) {
      candidates
        .filter(el => !el.dataset.einzekComponent && visible(el) && has(el, "h1,h2,h3,p,img,video,a,button"))
        .forEach((el, i) => {
          el.dataset.einzekReveal = ["fade-up","fade-left","fade-right","scale","clip"][i % 5];
          [...el.children].slice(0, 12).forEach((child, n) => {
            child.dataset.einzekChild = child.matches("img,picture,video") ? "scale" : "fade-up";
            child.style.setProperty("--einzek-delay", `${Math.min(n * C.staggerDelay, 720)}ms`);
          });
        });
    }

    $("[data-einzek-component='hero']", scope).forEach(hero => {
      const mediaParent = $("picture,img,video", hero)[0]?.parentElement;
      if (mediaParent) mediaParent.dataset.einzekMedia = "";
      const content = $("h1,h2,p,a,button", hero)[0]?.parentElement;
      if (content) content.dataset.einzekHeroContent = "";
      if (!hero.querySelector(".einzek-scroll-indicator")) hero.insertAdjacentHTML("beforeend", '<span class="einzek-scroll-indicator" aria-hidden="true"></span>');
    });

    $("a,button,input[type='submit']", scope).forEach(el => el.classList.add("einzek-button"));
    reveal.observeAll(scope);
  }

  const reveal = {
    io:null,
    init() {
      this.io = new IntersectionObserver(entries => {
        entries.forEach(e => e.isIntersecting && e.target.classList.add("einzek-in"));
      }, { threshold:.16, rootMargin:"0px 0px -8% 0px" });
    },
    observeAll(root=document) {
      if (reduce) return $("[data-einzek-reveal],[data-einzek-component]", root).forEach(el => el.classList.add("einzek-in"));
      $("[data-einzek-reveal],[data-einzek-component]", root).forEach(el => this.io.observe(el));
    }
  };

  function headerScroll() {
    const h = $("[data-einzek-component='header']")[0];
    if (!h) return;
    const y = scrollY;
    h.classList.toggle("einzek-header-glass", y > 8);
    h.classList.toggle("einzek-header-solid", y > 90);
    h.classList.toggle("einzek-header-shrink", y > 160);
  }

  function scrollEffects() {
    headerScroll();
    const p = document.querySelector(".einzek-progress");
    if (p) p.style.transform = `scaleX(${scrollY / (document.body.scrollHeight - innerHeight || 1)})`;
    if (!reduce) $("[data-einzek-component='hero']").forEach(hero => {
      hero.style.setProperty("--einzek-parallax", `${hero.getBoundingClientRect().top * -C.parallaxStrength}`);
    });
  }

  function interactions() {
    document.addEventListener("pointermove", e => {
      $("[data-einzek-component='product-card'],[data-einzek-component='collection-card']").forEach(card => {
        const r = card.getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
          card.style.setProperty("--einzek-spotlight-x", `${e.clientX - r.left}px`);
          card.style.setProperty("--einzek-spotlight-y", `${e.clientY - r.top}px`);
        }
      });
    }, { passive:true });

    document.addEventListener("click", e => {
      if (!C.rippleButtons) return;
      const b = e.target.closest(".einzek-button");
      if (!b) return;
      const r = b.getBoundingClientRect();
      const s = document.createElement("span");
      s.className = "einzek-ripple";
      s.style.left = `${e.clientX - r.left}px`;
      s.style.top = `${e.clientY - r.top}px`;
      b.appendChild(s);
      setTimeout(() => s.remove(), 750);
    }, { passive:true });
  }

  function init(root=document) {
    document.documentElement.classList.add("einzek-page-ready");
    if (C.progressBar && !document.querySelector(".einzek-progress")) document.body.insertAdjacentHTML("afterbegin", '<div class="einzek-progress" aria-hidden="true"></div>');
    analyze(root);
    scrollEffects();
  }

  reveal.init();
  interactions();
  addEventListener("scroll", () => requestAnimationFrame(scrollEffects), { passive:true });
  addEventListener("resize", () => requestAnimationFrame(scrollEffects), { passive:true });
  document.addEventListener("DOMContentLoaded", () => init());
  ["shopify:section:load","shopify:section:select","shopify:block:select"].forEach(evt => {
    document.addEventListener(evt, e => init(e.target));
  });
})();
    const elements = document.querySelectorAll(`
        section,
        .shopify-section,
        .banner,
        .collection,
        .featured-collection,
        .rich-text,
        .image-banner,
        .multicolumn,
        .slideshow,
        .card-wrapper
    `);

    elements.forEach(el=>{
        el.classList.add("ez-reveal");
    });

    const observer = new IntersectionObserver((entries)=>{

        entries.forEach(entry=>{

            if(entry.isIntersecting){

                entry.target.classList.add("ez-visible");

            }

        });

    },{
        threshold:.15
    });

    elements.forEach(el=>observer.observe(el));

});